import websites from '../../config/websites';

export default {
  computed: {
    websiteName() {
      return websites.currentWebsite().name;
    },
    websiteCategory() {
      return websites.currentWebsite().category;
    },
    websiteSecondCategory() {
      return websites.currentWebsite().secondCategory;
    },
    readMoreTags() {
      return websites.currentWebsite().readMoreTags;
    },
    websiteTags() {
      return [websites.currentWebsite().tag];
    },
    broadcastChannel() {
      return websites.currentWebsite().broadcastChannel;
    },
    websiteUrl() {
      return websites.currentWebsite().url;
    },
    websiteVimeoScope() {
      return websites.currentWebsite().vimeoScope;
    },
    websiteRSS() {
      return `http://rss.${websites.currentWebsite().url}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/website.js